export default __webpack_public_path__ + "static/media/IconDesc_Star.256.8df8b036.png";